import { render, staticRenderFns } from "./add_procurement.vue?vue&type=template&id=16e21285&scoped=true&"
import script from "./add_procurement.vue?vue&type=script&lang=js&"
export * from "./add_procurement.vue?vue&type=script&lang=js&"
import style0 from "./add_procurement.vue?vue&type=style&index=0&id=16e21285&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e21285",
  null
  
)

export default component.exports